export class GenericLabelValue {
	label: string;
	value: any;
	sortVal?: any;
	selected?: boolean;
	disabled?: boolean;
	meta?: string;
	faIconClass?: string;
	public constructor(init?: Partial<GenericLabelValue>) {
		Object.assign(this, init);
	}
}
